var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-symbol icon-menu-dashboard theme-undefined",
    "aria-hidden": "true",
    "data-testing-id": "icon-menu-dashboard",
    "data-element": "svg",
    "data-component": "SvgSymbol",
    "data-source-file": "SvgSymbol.jsx",
    style: {
      width: 24,
      height: 24
    },
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    fill: "current",
    viewBox: "0 0 25 25",
    id: "icon-menu-dashboard",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.992 3.365a2.75 2.75 0 0 1 2.75 2.75v12.5a2.75 2.75 0 0 1-2.75 2.75h-12.5a2.75 2.75 0 0 1-2.75-2.75v-12.5a2.75 2.75 0 0 1 2.75-2.75h12.5Zm0 1.5h-12.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-12.5c0-.69-.56-1.25-1.25-1.25ZM8.492 9.37c.38 0 .694.28.743.645l.007.102v6.506a.748.748 0 0 1-.75.747.75.75 0 0 1-.743-.646l-.007-.101v-6.506c0-.413.336-.747.75-.747Zm8.5-2c.38 0 .694.274.743.63l.007.1v8.54a.74.74 0 0 1-.75.73.744.744 0 0 1-.743-.63l-.007-.1V8.1a.74.74 0 0 1 .75-.73Zm-4.275 4.996a.73.73 0 0 1 .732.621l.008.099.035 3.547a.73.73 0 0 1-.725.733.73.73 0 0 1-.732-.62l-.007-.099-.036-3.547a.73.73 0 0 1 .725-.734Z"
  })))), /*#__PURE__*/React.createElement("use", {
    className: "svg-symbol icon-menu-dashboard theme-undefined",
    xlinkHref: "#icon-menu-dashboard",
    "data-element": "use",
    "data-source-file": "SvgSymbol.jsx",
    style: {
      width: 24,
      height: 24
    },
    fill: "#FFFFFF"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.8af1df21fde162a93b86dc3730897454.svg";
export { ForwardRef as ReactComponent };